import { render } from "./FormActionCard.vue?vue&type=template&id=7ff97fb0&scoped=true"
import script from "./FormActionCard.vue?vue&type=script&lang=ts"
export * from "./FormActionCard.vue?vue&type=script&lang=ts"

import "./FormActionCard.vue?vue&type=style&index=0&id=7ff97fb0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7ff97fb0"

export default script